export default __webpack_public_path__ + "static/media/share-sale-mobile.55957abf.png";